import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSession } from "api";
import {
  Session,
  Guid,
  APIReduxResponse,
  ResponseError,
  ApiStatus,
} from "types";

/**
 * Async Thunk API
 */
export const fetchSession = createAsyncThunk<
  APIReduxResponse<Session | ResponseError>,
  Guid["guid"]
>("auth/fetchSession", getSession);

export type AuthReducerState = {
  guid: string;
  cdkey: string;
  codcli: string;
  apiStatus: ApiStatus;
  session?: Session;
  errorResponse?: ResponseError;
  isLogged: boolean;
  showLogoutPage:boolean;
};

const initialState: AuthReducerState = {
  guid: "",
  cdkey: "",
  codcli: "",
  apiStatus: "idle",
  isLogged: false,
  showLogoutPage:false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setGuid: (state, action: PayloadAction<string>) => {
      state.guid = action.payload;
    },
    setIsLogged: (state, action: PayloadAction<boolean>) => {
      state.isLogged = action.payload;
    },
    setSession: (state, action: PayloadAction<Session>) => {
      state.session = action.payload;
    },
    setShowLogoutPage:(state, action:PayloadAction<boolean>)=>{
      state.showLogoutPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSession.pending, (state) => {
      state.apiStatus = "pending";
      state.errorResponse = undefined;
      state.session = undefined;
    });
    builder.addCase(fetchSession.rejected, (state) => {
      state.apiStatus = "rejected";
    });
    builder.addCase(fetchSession.fulfilled, (state, { payload }) => {
      const isSuccessResponse = payload.resposeStatus.status === 200;
      state.apiStatus = isSuccessResponse ? "fulfilled" : "rejected";
      if (isSuccessResponse) {
        state.session = payload.response as Session;
      } else {
        state.errorResponse = payload.response as ResponseError;
      }
    });
  },
});

export const { setGuid, setIsLogged, setSession, setShowLogoutPage } = authSlice.actions;

export const authSliceReducer = authSlice.reducer;
